export type SetNavbarStickyAction = {
  type: 'SET_NAVBAR_STICKY'
  sticky: boolean
}

export const setNavbarSticky = (sticky: boolean): SetNavbarStickyAction => {
  return {
    type: 'SET_NAVBAR_STICKY',
    sticky,
  }
}
